import {
  Component,
  EventEmitter,
  Input,
  Output,
} from "@angular/core";
import {
  FormGroup,
} from "@angular/forms";
import { Component_MAWP } from "../../../services/component_mawp";

/**
 * Child component for LTAP inspection data in MFH (Tank) mode.
 * Displays input fields and emits events to parent. No calculations here.
 * Parent passes FormGroup down via @Input, catches events via @Output.
 */
@Component({
    selector: "tanks-ltap-inspection-fields",
    templateUrl: "./tanks-ltap-inspection-fields.component.html",
    standalone: false
})
export class TanksLtapInspectionFieldsComponent {

    // INPUTS - passed DOWN from parent
    @Input() formGroup: FormGroup;
    @Input() intUnit: number;                        // 0 = US, 1 = SI
    @Input() isMfhMode: boolean;
    @Input() lmlProfileData_intnum_t_pt: number;     // Number of thickness measurements
    @Input() lmlProfileData_sngGrid_spacing: number; // Metal loss length / grid spacing

    // OUTPUTS - events sent UP to parent (formControlName → Output)
    @Output() comboBox1_change = new EventEmitter<string>();              // ltap_2s2cBox
    @Output() s_change = new EventEmitter<Event>();                       // ltap_metalLossLength_s
    @Output() numMeasurements_change = new EventEmitter<Event>();         // ltap_numMeasurements
    @Output() lmlProfileData_intnum_t_ptChange = new EventEmitter<number>();
    @Output() lmlProfileData_sngGrid_spacingChange = new EventEmitter<number>();
    @Output() fcaml_change = new EventEmitter<Event>();                   // ltap_fcaml
    // @Output() c_change = new EventEmitter<Event>();                   // ltap_circLength_c - DEPRECATED
    @Output() hml_change = new EventEmitter<Event>();                     // ltap_hml (tank-specific)
    @Output() lmsd_change = new EventEmitter<Event>();                    // ltap_lmsd
    @Output() gr_change = new EventEmitter<Event>();                      // ltap_grooveRadius_gr

    // Service reference for strD_iclass (damage type)
    component_mawp = Component_MAWP;

    // EVENT HANDLERS - emit to parent
    onComboBox1Change(value: string): void { this.comboBox1_change.emit(value); }
    onSChange(event: Event): void { this.s_change.emit(event); }
    onNumMeasurementsChange(event: Event): void { this.numMeasurements_change.emit(event); }
    onFcamlChange(event: Event): void { this.fcaml_change.emit(event); }
    // onCChange(event: Event): void { this.c_change.emit(event); }  // DEPRECATED
    onHmlChange(event: Event): void { this.hml_change.emit(event); }
    onLmsdChange(event: Event): void { this.lmsd_change.emit(event); }
    onGrChange(event: Event): void { this.gr_change.emit(event); }

    // Two-way binding helpers
    onInput_lmlProfileData_intnum_t_pt(event: Event): void {
        this.lmlProfileData_intnum_t_ptChange.emit(Number((event.target as HTMLInputElement).value));
    }
    onInput_lmlProfileData_sngGrid_spacing(event: Event): void {
        this.lmlProfileData_sngGrid_spacingChange.emit(Number((event.target as HTMLInputElement).value));
    }
}

